module.exports = __webpack_public_path__ + "static/img/DR_IMG.a1b02cc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Desktop/Home_Landing/DR_IMG.png
// module id = wNBF
// module chunks = 0